module.exports = ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 80
// module chunks = 0